import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui';
import { SOCIAL_LOGIN_ENABLED } from '@/config/cognito';
import { amplifyLanguageForLocale, type AppLocale } from './locales';
import authEn from '@/locales/en/auth.json';
import authEs419 from '@/locales/es-419/auth.json';
import authIt from '@/locales/it/auth.json';

type AmplifyAuthCopy = {
  sendCode: string;
  sending: string;
  orContinueEmail: string;
  continueGoogle: string;
  continueApple: string;
  signInTab: string;
  createAccount: string;
  email: string;
  password: string;
  enterEmail: string;
  enterPassword: string;
};

function putAmplifyVocab(language: string, amplify: AmplifyAuthCopy): void {
  I18n.putVocabulariesForLanguage(language, {
    'Send code': amplify.sendCode,
    Sending: amplify.sending,
    'Sign In': amplify.signInTab,
    'Create Account': amplify.createAccount,
    Email: amplify.email,
    Password: amplify.password,
    'Enter your Email': amplify.enterEmail,
    // Forgot-password builds `Enter your ${label.toLowerCase()}` → "Enter your email".
    'Enter your email': amplify.enterEmail,
    'Enter your Password': amplify.enterPassword,
    // Italian built-in dict uses lowercase "password"; cover both keys.
    'Enter your password': amplify.enterPassword,
    ...(SOCIAL_LOGIN_ENABLED
      ? {
          or: amplify.orContinueEmail,
          'Sign In with Google': amplify.continueGoogle,
          'Sign In with Apple': amplify.continueApple,
          'Sign Up with Google': amplify.continueGoogle,
          'Sign Up with Apple': amplify.continueApple
        }
      : {})
  });
}

/**
 * Register Amplify Authenticator string overrides.
 * Built-in dictionaries cover most Authenticator chrome; we layer brand copy on top.
 * SPA dialects use i18next; Amplify collapses Spanish to `es` (we use es-419 copy).
 */
export function applyAmplifyVocabularies(): void {
  I18n.putVocabularies(translations);
  putAmplifyVocab('en', authEn.amplify);
  putAmplifyVocab('es', authEs419.amplify);
  putAmplifyVocab('it', authIt.amplify);
}

export function syncAmplifyLanguage(locale: AppLocale): void {
  I18n.setLanguage(amplifyLanguageForLocale(locale));
}
